 $('.slider-show').slick({
    autoplay:false,
    speed:300 ,
    lazyLoad: 'ondemand',
    slidesToShow:3,
    slideToscroll:1,
    arrows:false,
    dots:true,
    infinite: true,//スライドをループさせるかどうか。初期値はtrue。
    centerMode: true, //要素を中央寄せ
    centerPadding: '10%',//左右の画像が見える幅
   
    responsive: [{
    breakpoint: 1488,//モニターの横幅が769px以下の見せ方
      settings: {
      slidesToShow: 2,//スライドを画面に2枚見せる
      centerPadding: '10%',//左右の画像が見える幅
       },},
    {
    breakpoint: 1200,//モニターの横幅が769px以下の見せ方
      settings: {
      slidesToShow: 1,//スライドを画面に2枚見せる
      centerPadding: '20%',//左右の画像が見える幅
       }, },
   {
    breakpoint: 767,//モニターの横幅が426px以下の見せ方
      settings: {
      slidesToShow: 1,//スライドを画面に1.5枚見せる
      centerPadding: '20%',//左右の画像が見える幅
      },},                 
   ],
   
});
